import OELicensingAccessTool from '../../../../react-oe/oe-licensing-access-tool';
import {OEViewType} from '../../../../lib/oe-types';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import OENotification from '../../../../lib/notification/oe-notification';
import OEMainMenuBtnAdapter from './oe-main-menu-btn-adapter';

export default class OEMainMenuBtnAdapterView extends OEMainMenuBtnAdapter {

    constructor(link, options, feature, licensingAccess) {
        super();
        this.link = link;
        this.options = options;
        this.feature = feature;
        this.licensingAccess = typeof(licensingAccess) === 'function' ? licensingAccess : undefined;

        this.state = {
            active: false,
            enabled: false,
            featureAvailable: true,
            licensingAccessible: true
        };

        this.connected = false;

        this.updateIsPresentable();
        this.updateFeatureAvailable();
        this.updateLicensingAccessible();

        this.onViewOpenStateChanged = this.onViewOpenStateChanged.bind(this);
        this.onViewPresentableStateChanged = this.onViewPresentableStateChanged.bind(this);
        this.onFeatureAccessChanged = this.onFeatureAccessChanged.bind(this);
        this.onLicensingProductActivationChanged = this.onLicensingProductActivationChanged.bind(this);
    }

    setState(state) {
        let newState = Object.assign({}, this.state, state);
        if(OEToolbox.shallowEqual(newState, this.state, true)) return;
        this.state = newState;
        if(this.menu) this.menu.updateForAdapter(this);
    }

    onConnect(oe, menu)  {
        this.connected = true;
        this.updateIsPresentable();
        this.updateFeatureAvailable();
        this.updateLicensingAccessible();
        this.updateState(menu);
        menu.props.appComponent.uiLayer.notificationCenter.register(OENotification.viewOpenStateChanged, this.onViewOpenStateChanged);
        menu.props.appComponent.uiLayer.notificationCenter.register(OENotification.viewPresentableStateChanged, this.onViewPresentableStateChanged);
        oe.sharedNotificationCenter.register(this.oe.NotificationName.featureAccessChanged, this.onFeatureAccessChanged);
        oe.sharedNotificationCenter.register(this.oe.NotificationName.licensingProductActivationChanged, this.onLicensingProductActivationChanged);
    }

    onRelease(oe, menu)  {
        this.connected = false;
        menu.props.appComponent.uiLayer.notificationCenter.unregister(OENotification.viewOpenStateChanged, this.onViewOpenStateChanged);
        menu.props.appComponent.uiLayer.notificationCenter.unregister(OENotification.viewPresentableStateChanged, this.onViewPresentableStateChanged);
        oe.sharedNotificationCenter.unregister(this.oe.NotificationName.featureAccessChanged, this.onFeatureAccessChanged);
        oe.sharedNotificationCenter.unregister(this.oe.NotificationName.licensingProductActivationChanged, this.onLicensingProductActivationChanged);
        this.setViewOpen(false, menu);
        this.updateFeatureAvailable();
        this.updateLicensingAccessible();
        this.updateState(menu);
    }

    setViewOpen(open, menu)   {
        menu = menu || this.menu;
        if(!menu)   return;
        let view = OEViewType.getRef(this.link, menu.props.appComponent);
        if(view && view.setOpen) view.setOpen(open, this.options);
    }

    updateIsPresentable()  {
        let view = this.menu ? OEViewType.getRef(this.link, this.menu.props.appComponent) : undefined;
        this.isPresentable = !(!view || (view && typeof(view.isPresentable) === 'function' && !view.isPresentable()));
    }

    updateFeatureAvailable()  {
        if(typeof(this.feature) !== 'number' || !this.oe || !this.oe.isReady() || !this.connected)   {
            this.featureAvailable = typeof(this.feature) !== 'number'; return;
        }
        let featureSet = this.oe.sharedInterface.getUIControllerFeatureAccess().getFeatureSet();
        this.featureAvailable = featureSet.hasFeature({value: this.feature});
        featureSet.delete();
    }

    updateLicensingAccessible()   {
        if(typeof(this.licensingAccess) !== 'function') {
            this.licensingAccessible = true; return;
        }

        let licensingAccess = OELicensingAccessTool.getLicensingAccess(this.oe, !this.connected);

        if(!licensingAccess.isLicensing)    {
            this.licensingAccessible = true; return;
        }

        let licensingAccessible = this.licensingAccess(this, licensingAccess, this.oe);

        this.licensingAccessible = typeof(licensingAccessible) === 'boolean' ? licensingAccessible : true;
    }

    onViewOpenStateChanged(message, userInfo)   {
        if(userInfo.type !== this.link) return;
        this.updateState();
    }

    onViewPresentableStateChanged(message, userInfo)   {
        if(userInfo.type !== this.link) return;
        let isPresentable = this.isPresentable;
        this.updateIsPresentable();
        if(isPresentable === this.isPresentable)  return;

        if(!this.isPresentable)   this.setViewOpen(false);

        this.updateState();
    }

    onFeatureAccessChanged(message, userInfo)   {
        let featureAvailable = this.featureAvailable;
        this.updateFeatureAvailable();
        if(featureAvailable === this.featureAvailable)  return;

        if(!this.featureAvailable)   this.setViewOpen(false);

        this.updateState();
    }

    onLicensingProductActivationChanged(message, userInfo)   {
        let licensingAccessible = this.licensingAccessible;
        this.updateLicensingAccessible();
        if(licensingAccessible === this.licensingAccessible)  return;

        if(!this.licensingAccessible)   this.setViewOpen(false);

        this.updateState();
    }

    updateState(menu)   {
        menu = menu || this.menu;
        let connected = this.oe && this.oe.isReady() && this.connected;
        let view = menu ? OEViewType.getRef(this.link, menu.props.appComponent) : null;

        this.setState({
            active: view && view.isOpen(),
            enabled: view && connected && this.featureAvailable && this.licensingAccessible && this.isPresentable ? true : false,
            featureAvailable: this.featureAvailable,
            licensingAccessible: this.licensingAccessible
        });
    }

    onPressed(activated, menu)   {
        if(!this.state.enabled) return this.state.active;
        this.setViewOpen(!activated, menu);
        this.updateState(menu);
        return this.state.active;
    }

    isActive(menu)   {
        return this.state.active;
    }

    isEnabled(menu) {
        return this.state.enabled;
    }

    isFeatureAvailable(menu) {
        return this.state.featureAvailable;
    }

    isLicensingAccessible(menu)    {
        return this.state.licensingAccessible;
    }
}